import React from 'react'
import classNames from 'classnames'

const Checkbox = ({
  id,
  label,
  subtext,
  defaultChecked,
  checked,
  className,
  onChange,
  disabled,
}) => {
  return (
    <label
      className={classNames(
        'checkbox-with-label',
        '-checkbox',
        className
      )}
    >
      <input
        className="checkbox-with-label__input"
        id={id}
        defaultChecked={defaultChecked}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        type="checkbox"
      />
      <div className="checkbox-with-label__checkbox" />
      {renderLabelAndSubtext(label, subtext)}
    </label>
  )
}

const renderLabelAndSubtext = (label, subtext) => {
  if (subtext) {
    return (
      <div>
        <div className="top-label">{label}</div>
        <div className="bottom-label">{subtext}</div>
      </div>
    )
  }

  return (
    <div>
      <div className="top-label">{label}</div>
    </div>
  )
}

export default Checkbox
